/**
 * Created by Andrey Popov on 07.08.26
 */

const InviteFriendsIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.invite_friends_icon_json,
        priority: SideBar.PRIORITY_REDUNDANT
    });
};

InviteFriendsIcon.prototype = Object.create(SideBarIcon.prototype);
InviteFriendsIcon.prototype.constructor = InviteFriendsIcon;

InviteFriendsIcon.prototype.onPressed = function () {
    cleverapps.inviteFriends.displayWindow();
};

InviteFriendsIcon.prototype.resetState = function () {
    const hidedByLocation = cleverapps.config.type !== "merge" && typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation;

    this.available = Boolean(cleverapps.inviteFriends) && cleverapps.inviteFriends.isAvailable()
        && connector.platform.listShareChannels().length > 0 && !hidedByLocation;

    this.setTitle(Messages.get("InviteFriendsWindow.invite"));

    this.setAttention(this.available && cleverapps.inviteFriends.hasUnclaimedRewards());
};
